// Shape /observations/focus-areas/ payloads into the row shape the JSX
// renders. The API already sorts by (standard_order, question_order).
export const normalizeApiFocusAreas = (apiResult) =>
  (apiResult?.areas || []).map((area, idx) => ({
    key: `${area.standard.uuid}-${area.question.uuid}`,
    domainNumber: area.standard.number || String(idx + 1),
    domainTitle: area.standard.title,
    fullText: area.question.text,
    count: area.not_observed_count,
  }));
